/*eslint complexity: ["error", 25]*/
import React from 'react';
import { Alert } from 'react-bootstrap';

import {
  CreateUpdateExcelConfigHeaderDto,
  GetExcelConfigHeaderDto,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import { usePokCore } from '../../../common/hooks/usePokCore';
import { useTranslation } from '../../../common/hooks/useTranslation';
interface AddHeaderAlertProps {
  header: CreateUpdateExcelConfigHeaderDto;
  headers?: GetExcelConfigHeaderDto[];
}

export const AddHeaderAlert: React.FC<AddHeaderAlertProps> = props => {
  const pok = usePokCore();
  const lang = pok.getLanguage();
  const { t, tk } = useTranslation('excelImportLng');

  let message = '';
  if (props.header?.pokColumnName === 'salesNetTotal') {
    message = t(tk.config.noNeedToAddSalesTotal, {
      fieldName:
        lang === 'PL'
          ? props.header.pokColumnNamePl
          : props.header.pokColumnNameEn,
    });
  }

  if (props.header?.pokColumnName === 'purchaseNetTotal') {
    message = t(tk.config.noNeedToAddPurchaseTotal, {
      fieldName:
        lang === 'PL'
          ? props.header.pokColumnNamePl
          : props.header.pokColumnNameEn,
    });
  }

  if (
    props.header?.pokColumnName === 'salesCommissionPercent' &&
    props.headers?.find(
      h => h.pokColumnName === 'salesCommissionAmount' && h.active,
    )
  ) {
    const salesCommissionAmount = props.headers.find(
      h => h.pokColumnName === 'salesCommissionAmount',
    );
    message = t(tk.config.noNeedToAddAnotherSalesCommissionField, {
      fieldName:
        lang === 'PL'
          ? props.header.pokColumnNamePl
          : props.header.pokColumnNameEn,
      salesCommissionFieldName:
        lang === 'PL'
          ? salesCommissionAmount?.pokColumnNamePl
          : salesCommissionAmount?.pokColumnNameEn,
    });
  }

  if (
    props.header?.pokColumnName === 'salesCommissionAmount' &&
    props.headers?.find(
      h => h.pokColumnName === 'salesCommissionPercent' && h.active,
    )
  ) {
    const salesCommissionPercent = props.headers.find(
      h => h.pokColumnName === 'salesCommissionPercent',
    );
    message = t(tk.config.noNeedToAddAnotherSalesCommissionField, {
      fieldName:
        lang === 'PL'
          ? props.header.pokColumnNamePl
          : props.header.pokColumnNameEn,
      salesCommissionFieldName:
        lang === 'PL'
          ? salesCommissionPercent?.pokColumnNamePl
          : salesCommissionPercent?.pokColumnNameEn,
    });
  }

  return <>{message && <Alert variant="warning">{message}</Alert>}</>;
};
